import React from "react";
import styled, { keyframes } from "styled-components";
import { FaRunning, FaShoePrints, FaTrophy } from "react-icons/fa";

const ChallengeLoader = () => {
  return (
    <LoaderWrapper>
      <IconTrail>
        <RunningIcon delay="0s"><FaRunning /></RunningIcon>
        <RunningIcon delay="0.2s"><FaShoePrints /></RunningIcon>
        <RunningIcon delay="0.4s"><FaTrophy /></RunningIcon>
      </IconTrail>
    </LoaderWrapper>
  );
};

export default ChallengeLoader;
const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.6; }
  40% { transform: translateY(-10px); opacity: 1; }
`;

const LoaderWrapper = styled.div`
  height: 85vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const IconTrail = styled.div`
  display: flex;
  gap: 20px;
`;

const RunningIcon = styled.div<{ delay: string }>`
  font-size: 52px;
  color: #78e9e1;
  animation: ${bounce} 1.2s infinite;
  animation-delay: ${({ delay }) => delay};
`;
